// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"82c8c9d1","455":"a7d8e2b0","488":"9cd832af","977":"c74b9558"}[chunkId] + ".chunk.js";
};